import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [RouterOutlet],
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
